import { defineComponent as _defineComponent } from 'vue'
import { ref, computed } from "vue";
  import { useStore } from "vuex";
  import { useToast } from "vue-toastification";
  import { DocumentTypeEnum } from "@/enums/DocumentTypeEnum";
  import { getDocumentName } from "@/helpers/documents";
  import { formatDate } from "@/helpers/date";
  import {
    isValidFileSize,
    isValidDocumentType,
    validDocumentsTypes,
  } from "@/helpers/fileUpload";
  import plural from "@/features/plural";
  import RemoveDocumentsModal from "@/components/ui/modals/RemoveDocumentModal.vue";
  import { FileText, Info, Trash2 } from "lucide-vue-next";

  interface Document {
    fileName: string;
    link: string;
    modifiedDate: string;
    mimetype: string;
  }

  interface Props {
    isOpen: boolean;
    lotId: string;
    lotTitle: string;
    documents: Document[];
  }

  
export default /*@__PURE__*/_defineComponent({
  __name: 'LotDocumentsModal',
  props: {
    isOpen: { type: Boolean },
    lotId: {},
    lotTitle: {},
    documents: {}
  },
  emits: ["close", "refresh"],
  setup(__props: any, { expose: __expose, emit: __emit }) {
  __expose();

  const props = __props;
  const emit = __emit;

  const store = useStore();
  const toast = useToast();

  const fileInput = ref<HTMLInputElement | null>(null);
  const isUploading = ref(false);
  const isDeleting = ref(false);
  const showDeleteModal = ref(false);
  const documentToDelete = ref<Document | null>(null);

  const documentTypes = validDocumentsTypes.join(", ");

  const estateId = computed(() => store.state.user.selectedEstateId);

  const close = () => {
    if (!isUploading.value && !isDeleting.value) {
      emit("close");
    }
  };

  const handleFileUpload = async (event: Event) => {
    const target = event.target as HTMLInputElement;

    if (!target.files || !target.files.length) {
      return;
    }

    const file = target.files[0];

    if (fileInput.value) {
      fileInput.value.value = "";
    }

    if (!isValidDocumentType(file)) {
      toast.error("Invalid file type. Please upload a valid document.");
      return;
    }

    if (!isValidFileSize(file)) {
      toast.error("File size exceeds the maximum limit.");
      return;
    }

    isUploading.value = true;

    try {
      const formData = new FormData();

      formData.append("file", file);
      formData.append("documentType", DocumentTypeEnum.DOCUMENTS);
      formData.append("lotId", props.lotId);
      formData.append("estateId", estateId.value);

      await store.dispatch("lot/uploadLotDocuments", formData);

      toast.success("Document uploaded successfully");
      emit("refresh");
    } catch (error) {
      toast.error("Failed to upload document. Please try again.");
    } finally {
      isUploading.value = false;
    }
  };

  const handleDeleteDocument = (doc: Document) => {
    documentToDelete.value = doc;
    showDeleteModal.value = true;
  };

  const confirmDelete = async () => {
    if (!documentToDelete.value) return;

    isDeleting.value = true;
    showDeleteModal.value = false;

    try {
      await store.dispatch("lot/deleteLotDocument", {
        lotId: props.lotId,
        fileName: documentToDelete.value.fileName,
        documentType: DocumentTypeEnum.DOCUMENTS,
      });

      toast.success("Document deleted successfully");
      emit("refresh");
    } catch (error) {
      toast.error("Failed to delete document. Please try again.");
    } finally {
      isDeleting.value = false;
      documentToDelete.value = null;
    }
  };

const __returned__ = { props, emit, store, toast, fileInput, isUploading, isDeleting, showDeleteModal, documentToDelete, documentTypes, estateId, close, handleFileUpload, handleDeleteDocument, confirmDelete, ref, computed, get useStore() { return useStore }, get useToast() { return useToast }, get DocumentTypeEnum() { return DocumentTypeEnum }, get getDocumentName() { return getDocumentName }, get formatDate() { return formatDate }, get isValidFileSize() { return isValidFileSize }, get isValidDocumentType() { return isValidDocumentType }, get validDocumentsTypes() { return validDocumentsTypes }, get plural() { return plural }, RemoveDocumentsModal, get FileText() { return FileText }, get Info() { return Info }, get Trash2() { return Trash2 } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})